import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

import { ModalConfirm } from '../../../../shared/models/modal-confirm.model';

@Component({
  selector: 'app-modal-confirm',
  templateUrl: './modal-confirm.page.html',
  styleUrls: ['./modal-confirm.page.scss'],
})
export class ModalConfirmPage implements OnInit {

  @Input() ModalConfirm: ModalConfirm = { text: '', backdropDismiss: true }

  constructor(
    private modalC: ModalController
  ) { }

  ngOnInit() {
  }

  public onConfirm(confirm: boolean) {
    this.modalC.dismiss(confirm)
  }

}
